import getCRUDHooks from '../../utils/services/getCRUDHooks';

const {
  useGet: useSignatory,
  useFind: useSignatories,
  useCreate: useSignatoryCreation,
  useUpdate: useSignatoryUpdate,
  useDelete: useSignatoryDeletion,
} = getCRUDHooks({
  entityName: 'signatories',
});

export {
  useSignatory,
  useSignatories,
  useSignatoryCreation,
  useSignatoryUpdate,
  useSignatoryDeletion,
};
